'use client';

import * as React from 'react';
import './styles.scss';

export const StickyGroup: React.FunctionComponent<{
  id: string;
  title?: string | null | undefined;
  children: React.ReactNode;
  level?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}> = (props) => {
  let Elem: keyof React.JSX.IntrinsicElements = 'h2';
  if (props.level) {
    Elem = props.level;
  }

  return (
    <div
      id={props.id}
      className={'sticky-group'}
    >
      {props.title && <Elem>{props.title}</Elem>}
      {props.children}
    </div>
  );
};
